import { Button, Stack } from "@mui/material";
import { useState } from "react";

import { AudioPlayer } from "../AudioPlayer";
import MediaPreviewDialog from "../MediaPreviewDialog/MediaPreviewDialog";
import { MediaPreviewFragment } from "./fragments.generated";

type Props = {
    media?: MediaPreviewFragment;
    size?: "small" | "large";
};

export function MediaPreview({ media, size = "small" }: Props) {
    const sizeInPixels = size === "small" ? 80 : 130;
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    return (
        <>
            <Stack
                sx={{
                    justifyContent: "center",
                    overflow: "hidden",
                    width: sizeInPixels,
                    height: sizeInPixels,
                    background: "#6769631c",
                    borderRadius: 1,
                }}
            >
                {media?.url &&
                    (media.mimeType.startsWith("audio") ? (
                        <AudioPlayer src={media.url} />
                    ) : (
                        <Button onClick={() => setIsDialogOpen(true)}>
                            <img
                                style={{ width: sizeInPixels, height: sizeInPixels, objectFit: "cover" }}
                                src={media.url}
                                alt={media.name}
                            />
                        </Button>
                    ))}
            </Stack>

            {media && <MediaPreviewDialog media={media} open={isDialogOpen} onClose={() => setIsDialogOpen(false)} />}
        </>
    );
}
